import React from 'react';

import {cn} from '../lib/helpers';

import {textStyle} from './text.module.css';

const Text = ({children, as: As = 'p', className, ...rest}) => {
  return (
    <As className={cn(textStyle, className)} {...rest}>
      {children}
    </As>
  );
};

export default Text;
